import { CategoryID } from '@sbt-web/network/types';
import { DisplayStrategyCallback } from '.';

export function create(): DisplayStrategyCallback {
  return (search) => {
    return Promise.resolve(
      !(
        search.category.id === CategoryID.Tutte &&
        search.geo.region.id === '0' &&
        (search.query == undefined || !search.query.length)
      )
    );
  };
}
